module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-bubble.ebd3df0b.png";